import { Reaction } from './types';

export type LimitedReaction =
  | Reaction.CELEBRATE
  | Reaction.LAUGH
  | Reaction.LIKE
  | Reaction.LOVE
  | Reaction.SAD
  | Reaction.THANK;

// istanbul ignore next
export const limitedReactions: LimitedReaction[] = [
  Reaction.CELEBRATE,
  Reaction.LAUGH,
  Reaction.LIKE,
  Reaction.LOVE,
  Reaction.SAD,
  Reaction.THANK,
];
